import { combineReducers } from 'redux';
import { registration } from './registration_reducer';
import { checkout } from './checkout_reducer';

const rootReducer = combineReducers({
  registration,
  checkout
});

export default rootReducer;